import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import toast from 'react-hot-toast'
import Header from '../components/Header'
import Footer from '../components/Footer'
import {
  customer_request_email,
  customer_update_password,
  messageClear,
  messageEmailClear,
} from '../store/reducers/authReducer'
import { useDispatch, useSelector } from 'react-redux'
import { FaEye, FaEyeSlash } from 'react-icons/fa'

const ForgotPassword = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  // const [email, setEmail] = useState('')
  const [customerId, setCustomerId] = useState(
    localStorage.getItem('customerID') || null
  )
  const location = useLocation()

  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const initialEmail =
    location.state?.verifiedEmail ||
    localStorage.getItem('emailForRegistration') ||
    ''

  const fromPage = location.state?.from || localStorage.getItem('fromPage')

  const {
    successMessage,
    errorMessage,
    successMessageEmail,
    errorMessageEmail,
    customerIdReturn,
  } = useSelector((state) => state.auth)

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  })

  useEffect(() => {
    // const fromPage = localStorage.getItem('fromPage')

    if (fromPage === 'forgot') {
      navigate('/forgotPassword')
    } else {
      navigate('/register', { state: { verifiedEmail: initialEmail } })
    }
  }, [initialEmail, navigate, fromPage])

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  // const submitEmail = async (e) => {
  //   e.preventDefault()

  //   if (!email) {
  //     toast.error('Please enter an email address')
  //     return
  //   }

  //   dispatch(customer_request_email({ email }))
  // }

  const submit = async (e) => {
    e.preventDefault()
    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match')
      return
    } else {
      const obj = {
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        customerId: customerId,
      }

      dispatch(customer_update_password(obj))
    }
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      navigate('/login')
       window.localStorage.removeItem('customerID')
      dispatch(messageClear())
    }
    if (errorMessage) {
      toast.error(errorMessage)

      dispatch(messageClear())
    }
  }, [successMessage, errorMessage])

  // useEffect(() => {
  //   if (successMessageEmail) {
  //     toast.success(successMessageEmail)
  //     setCustomerId(customerIdReturn)
  //     dispatch(messageEmailClear())
  //   }
  //   if (errorMessageEmail) {
  //     toast.error(errorMessageEmail)

  //     dispatch(messageEmailClear())
  //   }
  // }, [successMessageEmail, errorMessageEmail])

  return (
    <div>
      <Header />
      <div className="bg-slate-100 mt-4">
        <div className="w-full justify-center items-center p-10 sm:p-4">
          <div className="grid grid-cols-1 w-[30%] sm:w-full mx-auto bg-white rounded-md">
            <div className="px-8 py-8">
              <h2 className="text-center w-full text-xl text-slate-600 font-bold">
                Verify Your Email to Reset Password
              </h2>

              {/* {!customerId ? (
                <form onSubmit={submitEmail} className="text-slate-600">
                  <div className="flex flex-col gap-1 mb-2">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      required
                    />
                  </div>

                  <button className="px-8 w-full py-2 mt-4 bg-primary shadow-lg hover:bg-[#256398] text-white rounded-md">
                    Verify Email
                  </button>
                </form>
              ) : ( */}
              <form onSubmit={submit} className="text-slate-600">
                <div className="text-center text-slate-600">
                  {/* Password Field */}
                  <div className="flex flex-col gap-1 mb-2 relative">
                    <label htmlFor="password">Password</label>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      id="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      required
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      className="absolute right-3 top-[38px] cursor-pointer text-slate-500"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>

                  {/* Confirm Password Field */}
                  <div className="flex flex-col gap-1 mb-2 relative">
                    <label htmlFor="confirm-password">Confirm Password</label>
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      id="confirm-password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="w-full px-3 py-2 border border-slate-200 outline-none focus:border-[#256398] rounded-md"
                      required
                    />
                    <span
                      onClick={() => setShowConfirmPassword((prev) => !prev)}
                      className="absolute right-3 top-[38px] cursor-pointer text-slate-500"
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </div>
                <button className="px-8 w-full py-2 mt-4 bg-primary shadow-lg hover:bg-[#256398] text-white rounded-md">
                  Change Password
                </button>
              </form>
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ForgotPassword
